
import Vue from 'vue';
import { Unit } from '@/types';
import units from '@/services/units';
import chartService from '@/services/chart';
import Chart from '../components/Chart.vue';

export default Vue.extend({
  name: 'Dashboard',
  components: {
    Chart,
  },
  data() {
    return {
      items: [] as Unit[],
      countAll: 0,
      countRunning: 0,
      countShutdown: 0,
      countAddWater: 0,
      countServiceRequired: 0,
      countInactive: 0,
      chartData: {} as any,
      fields: [
        {
          label: 'Status',
          key: 'status',
          sortable: true,
        },
        {
          label: 'Count',
          key: 'count',
          sortable: true,
        },
      ],
      tableItems: [] as any[],
    };
  },
  methods: {
    async init(): Promise<void> {
      try {
        // all=true to include inactive units in the count
        const u = await units.readAll(true);
        this.items.splice(0, this.items.length);
        u.forEach((o: Unit) => {
          this.items.push(o);
          // Check if unit is inactive (no communication for more than 60 days)
          const isInactive = o.h2GenLastStatus === 'INACTIVE' || o.h2GenLastStatusFullText === 'Inactive';
          // Only count units that have a valid status
          if (isInactive) {
            this.countAll += 1;
            this.countInactive += 1;
          } else if (o.h2GenLastStatusCode === '00') {
            this.countAll += 1;
            this.countRunning += 1;
          } else if (o.h2GenLastStatusCode === '07' || o.h2GenLastStatusCode === '05') {
            this.countAll += 1;
            this.countShutdown += 1;
          } else if (o.h2GenLastStatusCode === '03' || o.h2GenLastStatusCode === '04' || o.h2GenLastStatusCode === '06') {
            this.countAll += 1;
            this.countServiceRequired += 1;
          } else if (o.h2GenLastStatusCode === '01') {
            this.countAll += 1;
            this.countAddWater += 1;
          }
          // Units without valid status are not counted in All Units
        });
        const title = 'Units Status';
        const labels = [] as string[];
        const data = [] as number[];
        const colours = [] as string[];
        this.tableItems.push({
          status: 'All Units',
          count: this.countAll,
          linkParameter: 'all',
        });
        if (this.countRunning > 0) {
          labels.push('Running');
          this.tableItems.push({
            status: 'Running',
            count: this.countRunning,
            linkParameter: 'running',
          });
          data.push(this.countRunning);
          colours.push('#42b23b');
        }
        if (this.countShutdown > 0) {
          labels.push('Shutdown');
          this.tableItems.push({
            status: 'Shutdown',
            count: this.countShutdown,
            linkParameter: 'shutdown',
          });
          data.push(this.countShutdown);
          colours.push('#cfcfdd');
        }
        if (this.countServiceRequired > 0) {
          labels.push('Service Required');
          this.tableItems.push({
            status: 'Service Required',
            count: this.countServiceRequired,
            linkParameter: 'service',
          });
          data.push(this.countServiceRequired);
          colours.push('#dd5555');
        }
        if (this.countAddWater > 0) {
          labels.push('Add Water');
          this.tableItems.push({
            status: 'Add Water',
            count: this.countAddWater,
            linkParameter: 'water',
          });
          data.push(this.countAddWater);
          colours.push('#254a96');
        }
        if (this.countInactive > 0) {
          labels.push('Inactive');
          this.tableItems.push({
            status: 'Inactive',
            count: this.countInactive,
            linkParameter: 'inactive',
          });
          data.push(this.countInactive);
          colours.push('#999999');
        }
        this.chartData = chartService.createPieChartData(title, labels, data, colours);
      } catch {
        // ignore for now...
      }
    },
  },
  async mounted(): Promise<void> {
    await this.init();
  },
});
